import React from 'react';
import { makeStyles } from '@material-ui/core';
import { timeFormat, timeFromUnixToStringFormat } from '../helpers/workingTimeHelper/generalWorkingTimeHelper';
import { colors } from '../consts/colors';
import { useGlobalStyles } from '../consts/globalStyles';
import { fonts } from '../consts/fonts';
import { KeyValue } from '../helpers/userHelper/generalUserHelper';
import WorkingTime from '../service/types/WorkingTime';
import BilledItem from './BilledItem';
import { RECORD_LIST_PARAMS } from './RecordListSummary';

interface Props {
	index: number;
	record: WorkingTime;
	users: KeyValue[];
}
function RecordItemSummary(props: Props) {
	const globalClasses = useGlobalStyles();
	const classes = useStyles();

	const reporter = React.useMemo(() => {
		return props.users.find((user) => user.value.id === props.record.reporter);
	}, [props.record, props.users]);

	const time = React.useMemo(() => {
		return timeFromUnixToStringFormat(props.record.duration);
	}, [props.record]);

	return (
		<div className={classes.wrapper}>
			<div className={classes.rangeWrapper}>
				<div className={classes.indexWrapper}>
					<span className={globalClasses.smallText}> {`${props.index + 1}.`}</span>
				</div>
				<div>
					<div className={classes.row}>
						<div className={classes.dateWrapper}>
							<span className={globalClasses.smallTextDark}>
								{props.record.date.format('DD.MM.YYYY')}
							</span>
						</div>
						<div className={classes.fromWrapper}>
							<span className={globalClasses.smallTextDark}>
								{props.record.startTime.format(timeFormat)}
							</span>
						</div>
						<div>
							<span className={globalClasses.smallTextDark}>&#8212;</span>
						</div>
						<div className={classes.toWrapper}>
							<span className={globalClasses.smallTextDark}>
								{props.record.endTime.format(timeFormat)}
							</span>
						</div>
					</div>
				</div>
			</div>
			<div className={classes.timeWrapper}>
				<div className={classes.timeTitleWrapper}>
					<span className={globalClasses.smallerTextLight}>{'Time: '}</span>
				</div>
				<div>
					<span className={globalClasses.mediumTextSemiDark}>{time}</span>
				</div>
			</div>
			<div className={classes.reporterWrapper}>
				<span className={globalClasses.smallTextDark}>{reporter?.key}</span>
			</div>
			<div className={classes.statusWrapper}>
				<BilledItem billed={props.record.billed!} />
			</div>
		</div>
	);
}

const useStyles = makeStyles(() => ({
	inputAddWrapper: {
		width: '100%',
		padding: '6px 0px',
		borderBottom: `1px solid ${colors.timetrackBorderd}`,
		transform: 'translateX(-10px)',
	},
	inputWrapper: {
		width: '95%',
	},
	indexWrapper: {
		display: 'flex',
		marginRight: '24px',
		alignItems: 'center',
	},
	fromWrapper: {
		display: 'flex',
		marginRight: '16px',
		alignItems: 'center',
	},
	toWrapper: {
		display: 'flex',
		marginLeft: '16px',
		alignItems: 'center',
	},
	timeTitleWrapper: {
		display: 'flex',
		marginRight: '12px',
		alignItems: 'center',
	},
	timeWrapper: {
		width: RECORD_LIST_PARAMS.TIME,
		display: 'flex',
		alignItems: 'center',
	},
	reporterWrapper: {
		display: 'flex',
		alignItems: 'center',
		width: RECORD_LIST_PARAMS.REPORTER,
	},
	statusWrapper: {
		width: RECORD_LIST_PARAMS.STATUS,
		display: 'flex',
		alignItems: 'center',
	},
	wrapper: {
		display: 'flex',
		padding: '20px 16px',
		margin: '4px 0px',
		border: `1px solid ${colors.timetrackBorderd}`,
		//backgroundColor: colors.billGreen,
	},
	rangeWrapper: {
		width: RECORD_LIST_PARAMS.RANGE,
		display: 'flex',
		alignItems: 'center',
	},
	smallTextLight: {
		fontSize: '12px',
		lineHeight: '16px',
		fontFamily: fonts.regular,
		color: colors.gray,
		letterSpacing: 0.4,
	},
	row: {
		display: 'flex',
		alignItems: 'center',
	},
	timeInputWrapper: {
		width: '45px',
		paddingLeft: '5px',
		transform: 'translateX(-6px)',
		padding: '0',
		border: `1px solid ${colors.addTimeBorder}`,
	},
	dateWrapper: {
		marginRight: '50px',
	},
}));

export default RecordItemSummary;
